/* eslint-disable import/prefer-default-export */
import { useStoreActions, useReducerData } from 'store/hooks';
// ACTIONS
import { first, get } from 'lodash';
import * as action from '../redux/actions';

const REDUCER_KEY = 'company';
export const useActions = () => {
  return useStoreActions({
    ...action,
  });
};

export const useMe = () => {
  const data = useReducerData('loginState', 'profile', null);
  const companyMaps = get(data, 'companyMaps', []);

  return {
    profile: data,
    company: first(companyMaps),
    lastLoginAt: data?.lastLoginAt,
  };
};

export const useGetCompanyDetail = () => {
  const { getCompanyDetail } = useActions();
  const data = useReducerData(REDUCER_KEY, 'overview.data', []);
  const loading = useReducerData(REDUCER_KEY, 'overview.loading', false);
  return { getCompanyDetail, data, loading };
};

export const useUpdateCompany = () => {};
